import { registerGlobalService } from "../service-provider/ServiceRegistry";
import { ApiError } from "../api/BaseApiError";
import { NotFoundError } from "../api/NotFoundError";
import { BadRequestError } from "../api/BadRequestError";
import { ForbiddenError } from "../api/ForbiddenError";
import { ServerError } from "../api/ServerError";
import { globalModule } from "../service-provider/GlobalModule";

export interface ApplicationError extends ApiError, Error { }

export interface ErrorHandler {
  handleErrorInSnackbar(error: ApplicationError | undefined): void;
  handleErrorInModal(error: ApplicationError | undefined): void;
  extractServerErrorMessage(error: any): any;
}

export class ErrorHandlerService implements ErrorHandler {
  handleErrorInSnackbar = (error: ApplicationError | undefined): void => {
    this.handleError(error, this.handleBadRequestErrorInSnackbar);
  };

  handleErrorInModal = (error: ApplicationError | undefined): void => {
    this.handleError(error, this.handleBadRequestErrorInModal);
  };

  private handleError = (
    error: ApplicationError | undefined,
    badRequestCallback: Function
  ): void => {
    if (!error) return;
    switch (error.constructor) {
      case BadRequestError:
        this.handleBadRequestError(error, badRequestCallback);
        break;
      case NotFoundError:
        window.location.href = "/404";
        break;
      case ForbiddenError:
        window.location.href = "/404";
        break;
      case ServerError:
        this.handleServerError(error);
        break;
      default:
        this.handleDefaultError(error);
    }
    if (error.formActions) error.formActions.setSubmitting(false);
  };

  extractServerErrorMessage = (error: any) => {
    const validationErrors = error?.response?.data?.Errors;
    if (!validationErrors) return error?.message;
    let errorMessage;
    Object.keys(validationErrors).forEach((key: string) => {
      if (!Array.isArray(validationErrors[key])) return;
      errorMessage = validationErrors[key][0];
    });

    return errorMessage;
  };

  private handleBadRequestError = (error: ApplicationError, badRequestCallback: Function) => {
    const badRequestError = error as BadRequestError;
    badRequestError.showErrorInForm();
    badRequestCallback(badRequestError);
  };

  private handleBadRequestErrorInSnackbar = (badRequestError: BadRequestError) => {
    badRequestError.showErrorInSnackbar();
  };

  private handleBadRequestErrorInModal = (badRequestError: BadRequestError) => {
    badRequestError.showErrorInModal();
  };

  private handleServerError = (error: ApplicationError) => {
    error.showErrorInSnackbar
      && error.showErrorInSnackbar();
  };

  private handleDefaultError = (error: ApplicationError) => {
    error.showErrorInSnackbar
      && error.showErrorInSnackbar();
  };
}

export const errorHandler = new ErrorHandlerService();
globalModule.errorHandler = errorHandler;
export default registerGlobalService(errorHandler as ErrorHandler);
